import { Check, Clear, Delete, ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, ButtonGroup, Grid, IconButton, TableCell, TableRow, TextField } from "@mui/material";
import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";
import { IComboBoxOption, IMaterial, MaterialContext } from "../../interfaces";
import { MaterialIdentifiers } from "../Shared/MaterialIdentifiers";
import { MaterialInfo } from "../Shared/MaterialInfo";
import { MaterialInputDialog } from "../MaterialInputDialog";
import { QuantityPicker } from "../Shared/FormControls/QuantityPicker";
import { grey, red } from "@mui/material/colors";


interface MUTRow {
    material: IMaterial,
    subtractQuantity: number,
    returnStatuses: IComboBoxOption[],
    onUpdate: (material: IMaterial, splitMaterial?: IMaterial) => void,
    onRemove: (qty: number) => void,
    readOnly: boolean,
}




export const MaterialUpdateTableRow: React.FC<MUTRow> = ({
    material,
    subtractQuantity,
    returnStatuses,
    onUpdate,
    onRemove,
    readOnly,
    ...props
}) => {

    const [removing, setRemoving] = useState(false);
    const [removeQty, setRemoveQty] = useState(1);

    const handleChangeReturnStatus = (value: string | null) => {

        let currentMaterial = cloneDeep(material);
        currentMaterial.expectedReturnState = returnStatuses.filter(x => x.value === value)[0];

        onUpdate(currentMaterial);
    }

    const handleRemove = () => {
        onRemove(removeQty);
        setRemoving(false);
        setRemoveQty(1);
    }

    const getActionColumnStyle = (statusId: number, removing: boolean) => {

        if (removing)
            return { width: '480px' }

        return (statusId === 1 && !readOnly) ? { width: '180px' } : {};

    }

    const qtyStyles = {
        remaining: {
            color: red[500],
            fontWeight: 'bold'
        },
        removed: {
            color: grey[700],
            textDecoration: 'line-through',
        },
    };

    useEffect(() => {

    }, [material])


    return (

        <TableRow className={"material-row" + (material.statusId === 1 || material.statusId === 5 ? " draft-material" : "")}>
            <TableCell>
                <Accordion elevation={0}>
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                    >
                        <div>
                            <p><strong>{material.l3}</strong></p>
                            <small>{material.l1?.value}</small>
                            <small>{material.l2?.value}</small>
                        </div>

                    </AccordionSummary>
                    <AccordionDetails>
                        <MaterialInfo material={material} />
                    </AccordionDetails>
                </Accordion>
            </TableCell>
            <TableCell>
                <p>{material.classes} </p>
            </TableCell>
            <TableCell>
                <p>{material.spareType?.value}</p>
            </TableCell>
            <TableCell>
                <MaterialIdentifiers material={material} />
            </TableCell>
            <TableCell>
                <p>{material.state?.value}</p>
            </TableCell>
            {!removing && <>
                <TableCell>
                    {subtractQuantity > 0 ? <Box>
                        <small style={qtyStyles.removed}>{material.quantity}</small>
                        <p style={qtyStyles.remaining}>{(material.quantity ?? 0) - subtractQuantity}</p>
                    </Box> :
                        <p>
                            {material.quantity}
                            {/*    <span>({material.unitOfQuantity.value})</span>*/}
                        </p>
                    }
                </TableCell>

                <TableCell>
                    {readOnly ?
                        <span>{material.expectedReturnState?.value}</span>
                        :
                        <Autocomplete
                            id="material-status"
                            options={returnStatuses.map(x => x.value)}
                            value={material.expectedReturnState?.value || null}
                            onChange={(_, value) => handleChangeReturnStatus(value)}
                            readOnly={readOnly}
                            renderInput={(params) => <TextField
                                {...params}
                                required
                                variant="standard"
                            />}
                        />
                    }
                </TableCell>
            </>
            }

            <TableCell colSpan={removing ? 3 : 1} sx={getActionColumnStyle(material.statusId ?? 0, removing)}>
                {
                    removing ?
                        <Box display="flex" alignItems="center">
                            <Box sx={{ minWidth: '140px' }}>
                                <QuantityPicker
                                    action={"Removing"}
                                    available={(material.quantity ?? 0) - subtractQuantity}
                                    value={removeQty}
                                    onChange={setRemoveQty}
                                />
                            </Box>
                            <Box sx={{ ml: 1 }}>
                                <ButtonGroup>
                                    <IconButton
                                        color="error"
                                        onClick={() => handleRemove()}
                                    >
                                        <Check />
                                    </IconButton>
                                    <IconButton
                                        color="primary"
                                        onClick={() => setRemoving(false)}
                                    >
                                        <Clear />
                                    </IconButton>
                                </ButtonGroup>
                            </Box>

                        </Box>
                        :
                        readOnly === false && <>

                            <MaterialInputDialog
                                entity={{ id: "", type: "CONTRACTVARIATION" }}
                                context={MaterialContext.MaterialRow}
                                onSubmitMaterial={(material, splitMaterial) => onUpdate(material, splitMaterial)}
                                material={material}
                                focus={false}
                            />




                            <IconButton aria-label="remove material" onClick={() => setRemoving(true)}>
                                <Delete />
                            </IconButton>



                        </>

                }
            </TableCell>
        </TableRow >
    );
}

